import { spawnYesNoDialog } from "$root/components/spawnable/yes-no-dialog";
import { pluralize } from "$root/utils";
import { Text } from "@mdotm/shadcn/legacy/components";

export type SpawnRenameTagOptionDialogParams = {
	currentTagValue: string;
	newTagValue: string;
	/** Portfolios carrying the option, as `tag-usage` counts them. */
	investmentCount: number;
	/** Filter criteria the rename will rewrite, across every workspace of every user of the client. */
	filterCount: number;
};

/**
 * State the blast radius of a rename before it is applied.
 *
 * The numbers are the point. A rename reaches portfolios the user cannot see from here and the workspaces
 * of other users of the client, so the count is the only place that scope is ever shown.
 */
export function spawnRenameTagOptionDialog(params: SpawnRenameTagOptionDialogParams): Promise<boolean> {
	const { currentTagValue, newTagValue, investmentCount, filterCount } = params;

	const usages = [pluralize(investmentCount, "portfolio"), pluralize(filterCount, "filter")];

	const untouched = investmentCount === 0 && filterCount === 0;

	return spawnYesNoDialog({
		size: "medium",
		header: "Are you sure you want to rename this option?",
		yesButton: "Proceed",
		noButton: "Cancel",
		children: (
			<div className="flex flex-col gap-3">
				<Text type="Body/L/Book" as="p">
					{untouched ? (
						<>
							<strong>{currentTagValue}</strong> is not in use. Renaming it will make it <strong>{newTagValue}</strong>.
						</>
					) : (
						<>
							<strong>{currentTagValue}</strong> is used on {usages.join(" and in ")}; renaming it will make it{" "}
							<strong>{newTagValue}</strong> in all of them.
						</>
					)}
				</Text>
				<Text type="Body/L/Book" as="p">
					This includes the workspaces of <strong>all other users under this customer.</strong>
				</Text>
			</div>
		),
	});
}
